import { render, staticRenderFns } from "./orderCgApprove.vue?vue&type=template&id=08ed4d52&scoped=true"
import script from "./orderCgApprove.vue?vue&type=script&lang=js"
export * from "./orderCgApprove.vue?vue&type=script&lang=js"
import style0 from "./orderCgApprove.vue?vue&type=style&index=0&id=08ed4d52&prod&scoped=true&lang=css"
import style1 from "./orderCgApprove.vue?vue&type=style&index=1&id=08ed4d52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed4d52",
  null
  
)

export default component.exports